// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/** The path the API serves the OAuth authorization endpoint on. */
const OAUTH_AUTHORIZE_PATH = '/oauth/authorize';

/** Reports whether a login redirect points at the API origin. */
export function isAPIOriginRedirect(redirectURL: string): boolean {
  try {
    return (
      new URL(redirectURL).origin ===
      new URL(import.meta.env.VITE_API_URL).origin
    );
  } catch {
    // A relative path is not a URL, and it stays inside the application
    return false;
  }
}

/** Sends a person who just signed in to where their login was headed. */
export function followLoginRedirect(
  redirectURL: string | undefined,
  destinations: { toHome: () => void; toRoute: (path: string) => void }
): void {
  if (redirectURL === undefined) {
    destinations.toHome();
    return;
  }

  // The OAuth authorization endpoint lives on the API origin, so returning to it means
  // leaving the application rather than pushing a route onto it
  if (isAPIOriginRedirect(redirectURL)) {
    // A sign-in only leaves the application to finish an authorization, so any other API address goes home.
    if (new URL(redirectURL).pathname !== OAUTH_AUTHORIZE_PATH) {
      destinations.toHome();
      return;
    }

    window.location.assign(redirectURL);
    return;
  }

  destinations.toRoute(redirectURL);
}
